import Axios from 'axios';
import qs from 'qs';

interface wxConfig {
  errorCode?: null | string | number;
  jsapi_ticket: string;
  nonceStr: string;
  respCode: string | number;
  respMsg: string;
  signature: string;
  timestamp: string | number;
  url: string;
}

interface config {
  title: string;
  imgUrl?: string;
}

export const setWechatShare = async (config: config) => {
  const { title, imgUrl } = config;

  const url = window.location.href;
  const params = {
    url,
  };

  const res = await Axios.post(
    'https://ar.lanxiongtiyu.com/ar_api/v1/wx/getTicketSign.do',
    qs.stringify(params)
  );

  const wxConfig: wxConfig = res.data;

  (window as any).wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: 'wx4690a55401737a1f', // 必填，公众号的唯一标识
    timestamp: wxConfig.timestamp, // 必填，生成签名z 的时间戳
    nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
    signature: wxConfig.signature, // 必填，签名
    jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'], // 必填，需要使用的JS接口列表
  });

  (window as any).wx.ready(() => {
    const timeLineConf = {
      title,
      imgUrl:
        imgUrl ||
        'http://imgcdn.lanxiongsports.com/upload/lanxiong/share-lx-logo.jpg',
    };

    const friendsConf = {
      title,
      // desc:
      link: url,
      imgUrl:
        imgUrl ||
        'http://imgcdn.lanxiongsports.com/upload/lanxiong/share-lx-logo.jpg',
    };

    (window as any).wx.onMenuShareTimeline(timeLineConf);
    (window as any).wx.onMenuShareAppMessage(friendsConf);
  });
};
